import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import { styles } from './styles';

export default function UserImage({
  email,
  firstName,
  lastName,
  displayCount,
  handleClick,
  bgColor,
}) {
  const classes = styles();

  const handleImageClick = (e) => {
    if (handleClick) {
      handleClick(e);
    }
  };

  return (
    <Tooltip title={!displayCount ? email : ''} arrow>
      <div
        id={`userImage-${firstName}${lastName}`}
        className={classes.userImage}
        onClick={handleImageClick}
        style={{ backgroundColor: bgColor || '#BAC0D0' }}
      >
        {displayCount && `+${displayCount}`}
        {firstName && lastName && `${firstName.charAt(0)}${lastName.charAt(0)}`}
      </div>
    </Tooltip>
  );
}
